module.exports = __webpack_public_path__ + "images/emoji/shipit.61d1accb3c5e4d2a98e4.png";